var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useEffect, useState, useRef } from 'react';
import { Modal, Animated } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import styled from 'styled-components/native';
import IcX from '@/assets/icon/ic_x_black.svg';
import SccPressable from '@/components/SccPressable';
import SccRemoteImage from '@/components/SccRemoteImage';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { setDismissedToday } from '@/atoms/challengeModalAtoms';
export default function LastMonthRankingModal(_a) {
    var { challengeId, imageUrl, onClose, visible: _visible } = _a, props = __rest(_a, ["challengeId", "imageUrl", "onClose", "visible"]);
    const [visible, setVisible] = useState(_visible);
    const [isReady, setIsReady] = useState(false);
    const fadeAnim = useRef(new Animated.Value(0)).current;
    useEffect(() => {
        setVisible(_visible);
        if (_visible) {
            fadeAnim.setValue(0);
            setIsReady(false);
        }
    }, [_visible, fadeAnim]);
    const handleClose = () => {
        setVisible(false);
        onClose();
    };
    const handleImageReady = () => {
        setIsReady(true);
        Animated.timing(fadeAnim, {
            toValue: 1,
            duration: 250,
            useNativeDriver: true,
        }).start();
    };
    const content = (_jsx(AnimatedBackdrop, { style: { opacity: fadeAnim }, children: _jsx(SafeContent, { edges: ['top', 'bottom'], children: _jsxs(Container, { children: [_jsxs(ImageContainer, { children: [_jsx(SccRemoteImage, { imageUrl: imageUrl, onReady: handleImageReady, resizeMode: "cover" }), _jsx(CloseButton, { onPress: handleClose, elementName: "last_month_ranking_modal_close", logParams: { challengeId }, children: _jsx(IcX, { color: color.black }) })] }), _jsx(CheckboxContainer, { children: _jsx(SccPressable, { onPress: () => {
                                setDismissedToday(challengeId);
                                setVisible(false);
                                onClose();
                            }, elementName: "last_month_ranking_modal_dont_show_today", logParams: { challengeId }, children: _jsx(DismissTodayLabel, { children: "\uC624\uB298 \uD558\uB8E8\uB3D9\uC548 \uBCF4\uC9C0 \uC54A\uAE30" }) }) })] }) }) }));
    return isReady ? (_jsx(Modal, Object.assign({ visible: visible, statusBarTranslucent: true, transparent: true }, props, { children: content }))) : (_jsx(HiddenView, { children: content }));
}
const AnimatedBackdrop = styled(Animated.View)({
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.7)',
});
const SafeContent = styled(SafeAreaView)({
    flex: 1,
    justifyContent: 'center',
    padding: 20,
});
const Container = styled.View({
    width: '100%',
    backgroundColor: color.white,
    borderRadius: 20,
    overflow: 'hidden',
});
const ImageContainer = styled.View({
    width: '100%',
    position: 'relative',
});
const CheckboxContainer = styled.View({
    padding: 16,
});
const DismissTodayLabel = styled.Text({
    color: color.gray70,
    fontSize: 14,
    fontFamily: font.pretendardRegular,
    borderBottomWidth: 0.5,
    borderBottomColor: color.gray70,
    paddingBottom: 0,
    alignSelf: 'flex-start',
});
const CloseButton = styled(SccTouchableOpacity)({
    position: 'absolute',
    top: 18,
    right: 18,
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: color.gray30,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
});
const HiddenView = styled.View({
    width: 0,
    height: 0,
});
